export default {"src":"/_next/static/media/email-logo-hover.bd753aff.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};